import React from "react";

export const sideBarAdmin = [
	{
		title: "View Reports",
		link: "/dashboard/admin/viewreports",
	},
	{
		title: "Doctor Signup Requests",
		link: "/dashboard/admin/doctorreqs",
	},
];
